import React from 'react'
import { MultiSelect } from 'primereact/multiselect'
import { Calendar } from 'primereact/calendar'
import utils from '../../../utils/index'
import LtsMultiselectUnidade from '../../../components/lottus/lts-multiselect-unidade'

/**
 * noAgendamento: o formulario dentro do dialogo de agendamento (AgendarRelatorioDialog), sem as datas (que la vao
 * para a grade de formulas) e sem seguir a unidade escolhida no topo.
 */
export const ContasReceberRelatorioForm = (props) => {
  const record = props.record
  const changeHandler = props.changeHandler

  return (
    <div>
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
                <LtsMultiselectUnidade
                  name="unidade"
                  label="Unidade"
                  value={record.unidade}
                  onChange={(e) => props.onChangeUnit(e)}
                  ignorarUnidadeDoTopo={props.noAgendamento}
                />
              </div>
            </div>

            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
                <label className="label">Forma de Pagamento</label>
                <MultiSelect
                  value={record.tipoFormaPagamento}
                  options={utils.convertArrayIdValueToIdLabel(props.formasPagamento)}
                  name="tipoFormaPagamento"
                  optionLabel="label"
                  dataKey="id"
                  selectedItemsLabel="{0} itens selecionados"
                  onChange={changeHandler}
                />
              </div>
            </div>

            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
                <label className="label">Grupo Financeiro</label>
                <MultiSelect
                  value={record.gruposFinanceiros}
                  options={utils.convertArrayIdValueToIdLabel(record.gruposFinanceirosOpcoes)}
                  name="gruposFinanceiros"
                  optionLabel="label"
                  dataKey="id"
                  selectedItemsLabel="{0} itens selecionados"
                  onChange={changeHandler}
                  filter={true}
                />
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
                <label className="label">Tipo de Sepultura</label>
                <MultiSelect
                  value={record.tiposSepulturas}
                  options={utils.convertArrayIdValueToIdLabel(record.opcoesTiposSepulturas)}
                  selectedItemsLabel="{0} itens selecionados"
                  name="tiposSepulturas"
                  optionLabel="label"
                  dataKey="id"
                  onChange={props.changeHandler}
                />
              </div>
            </div>
            {!props.noAgendamento && (
              <React.Fragment>
                <div className="p-grid form-group">
                  <div className="p-col-5 p-sm-4 p-md-2 p-lg-2 p-xl-2">
                    <label className="label">Emissão: De</label>
                    <Calendar
                      yearNavigator={true}
                      yearRange={utils.getYearRangeFromDate('1900')}
                      monthNavigator={true}
                      value={record.dataInicial}
                      onChange={changeHandler}
                      name="dataInicial"
                    />
                  </div>
                  <div className="p-col-5 p-sm-4 p-md-2 p-lg-2 p-xl-2">
                    <label className="label">Até</label>
                    <Calendar
                      yearNavigator={true}
                      yearRange={utils.getYearRangeFromDate('1900')}
                      monthNavigator={true}
                      value={record.dataFinal}
                      onChange={changeHandler}
                      name="dataFinal"
                    />
                  </div>
                </div>
                <div className="p-grid form-group">
                  <div className="p-col-5 p-sm-4 p-md-2 p-lg-2 p-xl-2">
                    <label className="label">Vencimento: De</label>
                    <Calendar
                      yearNavigator={true}
                      yearRange={utils.getYearRangeFromDate('1900')}
                      monthNavigator={true}
                      value={record.dataVencimentoInicial}
                      onChange={changeHandler}
                      name="dataVencimentoInicial"
                    />
                  </div>
                  <div className="p-col-5 p-sm-4 p-md-2 p-lg-2 p-xl-2">
                    <label className="label">Até</label>
                    <Calendar
                      yearNavigator={true}
                      yearRange={utils.getYearRangeFromDate('1900')}
                      monthNavigator={true}
                      value={record.dataVencimentoFinal}
                      onChange={changeHandler}
                      name="dataVencimentoFinal"
                    />
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
